import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7czabpidt2: FaireBrandEntity = {
  token: "b_7czabpidt2",
  type: "brand",
  name: "Deep River Snacks",
  avatarUrl:
    "https://cdn.faire.com/fastly/b41e4e7f78fc3a0a97078b59719220d6c9ad0e3d323e9b67a3465d93943b28cb.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b089311554b34c6d5eb92f70f9854319c92b589ad39efd1d0354901b076cf6e4.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b41e4e7f78fc3a0a97078b59719220d6c9ad0e3d323e9b67a3465d93943b28cb.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b089311554b34c6d5eb92f70f9854319c92b589ad39efd1d0354901b076cf6e4.jpeg",
  location: "150 Carol Place Moonachie, NJ, USA",
  minimumOrderDollars: 40,
  rating: 4.8,
  reviewCount: 9,
  isInsider: true,
  description:
    "Deep River Snacks is all about crafting bold flavors with simple, clean ingredients. Since\nour founding in 2002, we've been committed to making deliciously crunchy kettle-cooked\nchips using only the best ingredients available. Our dedication to quality means that we\nnever use artificial colors, flavors, preservatives, and are gluten-free and we are always\nmade in a nut-free facility. From our classic Sea Salt chips to our more adventurous\nflavors like Mesquite BBQ and Zesty Jalapeno, we're on a mission to provide snack lovers\nwith a better, tastier chip. We believe that great flavor should never come at the cost of\nquality, and we're proud to bring that philosophy to every bag of Deep River Snacks.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:59.648Z",
    importedBy: "entity-db-cli",
  },
};
